import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../../components/AppIcon';

const LoginHeader = () => {
  const { t } = useTranslation();
  return (
    <div className="text-center mb-6 md:mb-8">
      <div className="flex justify-center mb-4 md:mb-6">
        <div className="w-14 h-14 md:w-16 md:h-16 rounded-xl bg-accent/10 flex items-center justify-center">
          <Icon name="BookOpen" size={32} className="text-accent" />
        </div>
      </div>
      <h1 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground mb-2 md:mb-3">
        {t('auth.login.title')}
      </h1>
      <p className="text-sm md:text-base text-muted-foreground max-w-md mx-auto">
        {t('auth.login.subtitle')}
      </p>
    </div>
  );
};

export default LoginHeader;
